import styled from "@emotion/styled";
import Socials from "../components/Socials";
import { Box, Grid, Paper, Typography } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: "black",
}));

export default function Home() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography sx={{ fontWeight: "bold", fontSize: 30 }}>
        🤙 Contact
      </Typography>
      <Grid>
        <Item>
          <Socials />
        </Item>
      </Grid>
    </Box>
  );
}
